"use client";
import { useState } from "react";
import type { PlpParams } from "@/app/(static)/produkter/[[...category]]/page";
import type { HeroStoryblok } from "@/generated/sb/sb-types";
import { usePlp } from "@/lib/centra/hooks/usePlp";
import type { InitialPlpData } from "../../serverUtils/getInitialPlpData";
import PlpTopBar from "../PlpTopBar";
import { ProductCardListSkeleton } from "../ProductCardList";
import ProductsSection from "../ProductsSection/ProductsSection";

type Props = {
  showFilters?: boolean;
  initialProductData: InitialPlpData["products"];
  currentCategory: string[];
  categories: InitialPlpData["categories"];
  params?: PlpParams;
  initialFilterData?: InitialPlpData["initialFilterData"];
  listingBloks?: HeroStoryblok[];
  search?: string;
};

const ClientPlp = ({
  showFilters = true,
  categories,
  params,
  initialProductData,
  currentCategory,
  initialFilterData,
  search,
}: Props) => {
  const { ModalsProps, ProductsData } = usePlp(
    initialProductData,
    currentCategory,
    initialFilterData,
    search,
  );

  const [gridSize, setGridSize] = useState(4);

  return (
    <>
      {showFilters && (
        <PlpTopBar
          tags={ModalsProps.filterModalProps.tags ?? []}
          gridSize={gridSize}
          setGridSize={setGridSize}
          sortOrder={ModalsProps.SortOrderProps}
          filters={{
            ...ModalsProps.filterModalProps,
            categories,
            params,
          }}
        />
      )}

      {ProductsData.isLoading && <ProductCardListSkeleton amount={8} />}

      {ProductsData.plpContent && (
        <ProductsSection data={ProductsData} gridSize={gridSize} />
      )}
    </>
  );
};

export default ClientPlp;
